export const isCiValid = (ci: string | undefined) => {
  if (!ci) return false;

  const ciFixed = ci.length < 8 ? ci.padStart(8, '0') : ci;

  const coef = [2, 9, 8, 7, 6, 3, 4];
  let total = 0;

  for (let i = 0; i <= 6; i++) {
    const digit = Number(ciFixed[i]);
    if (isNaN(digit)) return false;
    total += (digit * coef[i]) % 10;
  }

  const aux = total % 10 === 0 ? total : 10 - (total % 10) + total;
  const verificatorNumber = aux - total;
  const lastDigit = Number(ciFixed[7]);
  return verificatorNumber === lastDigit;
};
